import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { useLanguage } from '../../contexts/LanguageContext';

export const ReceiptPage: React.FC = () => {
  const { theme } = useTheme();
  const { t } = useLanguage();

  return (
    <div className={`content-section ${theme.isDark ? 'dark' : 'light'}`}>
      <h2>{t('menu.receipt')}</h2>
      <p>Страница поступления товаров в разработке...</p>
    </div>
  );
};
